// extracted by mini-css-extract-plugin
export default {"BulletedList__ul":"zc_MU7PGY5","BulletedList__li":"RWYAPmGusX"};